<template>
  <div class="pausenplan">
    <div class="overlayMain" v-if="!MAINTENANCE && showIdentify"></div>
    <div class="overlayText" v-if="!MAINTENANCE && showIdentify">
      {{ pausenplanIdentifier }}
    </div>

    <div class="maintenance" v-if="MAINTENANCE">
      <div style="color: #fff; text-align: center;font-size: 80px;padding-top: 100px;">
        <i class="fas fa-exclamation-triangle fa-5x"></i><br /><br />
        {{ $t('maintenance.title') }}<br />
        <div style="font-size: 42px">
          <br />
          {{ $t('maintenance.message') }}
        </div>
      </div>
    </div>

    <div class="content" id="content" v-if="!MAINTENANCE">
      <div class="header" v-bind:style="{ 'padding-top': headerPadding + 'px' }">
        <div class="header-image">
          <img style="width: 50px; height: 50px" src="images/mz-logo.png" />
        </div>
        <div class="header-text">
          <img style="width: 177px; height: 50px" src="images/mz-logo-text-white.png" />
        </div>
        <div class="time-backdrop"></div>
      </div>

      <div class="position" v-for="position in positions.filter(showPosition)" :key="position.id">
        <div class="outer">
          <div
            class="header"
            v-bind:style="{
              'background-color': position.color,
              color: GetContrastingColor(position.color)
            }"
          >
            {{ GetPositionName(position) }}
          </div>
          <div
            style="
              display: inline-block;
              overflow: hidden;
              width: calc(100% - 305px);
              height: 30px;
            "
            v-bind:style="{ 'background-color': '#fff' }"
          >
            <!-- position.color -->
          </div>
        </div>

        <div
          class="outer employee-column"
          v-for="employee in position.employees.filter((employee) => employee.show)"
          :key="'employee:' + employee.employee_id"
          v-bind:style="{
            height: rowHeightCurrent + 'px',
            opacity: EmployeeShiftEnded(employee) ? actualShiftEndedOpacity : ''
          }"
        >
          <div
            class="employee"
            v-bind:class="{
              'overtime-show': (employee.not_logged_in && employee.notLoggedInMinutes <= 45) || employee.not_logged_out || (!employee.not_logged_in && employee.additionalPauseMandatory),
              'pause-show': GetEmployeePauseCurrent(employee)
            }"
            style="display: inline-block; overflow: hidden"
          >
            <div class="bg" style="">
              <div
                v-if="employee.extern"
                style="
                  position: absolute;
                  background-color: rgb(189, 108, 23);
                  text-align: center;
                  color: #fff;
                "
                v-bind:style="[GetExternMarkerStyle()]"
              >
                <i class="fas fa-location-arrow" v-bind:style="[GetExternMarkerIconStyle()]" style="position: static; display: block"></i>
              </div>
              <div style="float: left">
                <img
                  v-bind:src="GetProfilePicture(employee)"
                  style="
                    width: 40px;
                    height: 40px;
                    margin: 5px 10px 5px 5px;
                    border-radius: 100px;
                  "
                  v-bind:style="[GetEmployeePictureStyle()]"
                />
              </div>
              <div class="firstname" v-if="rowHeightCurrent >= 35" v-bind:style="[{ color: employee.underage ? '#d62d2d' : '#404040' }, GetEmployeeNameStyle('first'), GetEmployeeNameMargin()]">
                {{ GetEmployeeFirstName(employee) }}
              </div>
              <div class="lastname" v-if="rowHeightCurrent >= 35" v-bind:style="[{ color: employee.underage ? '#d62d2d' : '#404040' }, GetEmployeeNameStyle('last'), GetEmployeeNameMargin()]">
                {{ GetEmployeeLastName(employee) }}
              </div>
              <div class="name" v-if="rowHeightCurrent < 35" v-bind:style="[GetEmployeeNameMargin()]">
                <div class="firstname" v-bind:style="[{ color: employee.underage ? '#d62d2d' : '#404040' }, GetEmployeeNameStyle('first')]">
                  {{ GetEmployeeFirstName(employee) }}
                </div>
                <div class="lastname" v-bind:style="[{ color: employee.underage ? '#d62d2d' : '#404040' }, GetEmployeeNameStyle('last')]">
                  {{ GetEmployeeLastName(employee) }}
                </div>
              </div>
              <div class="fas fa-clock" v-if="employee.not_logged_in && employee.notLoggedInMinutes <= 45" v-bind:style="[GetIconSize()]"></div>
              <div class="fas" v-if="GetEmployeePauseCurrent(employee)" v-bind:class="[GetEmployeePauseCurrent(employee).duration >= 30 * 60 ? 'fa-utensils' : 'fa-coffee']" v-bind:style="[GetIconSize()]"></div>
              <div class="pause-time" v-if="GetEmployeePauseCurrent(employee)">
                {{ GetPauseTimeRemainingText(GetEmployeePauseCurrent(employee)) }}
              </div>
              <div class="name-shadow"></div>
            </div>
          </div>

          <div class="timebar" v-bind:style="GetTimeBarHeight('bar')">
            <div
              style="
                position: relative;
                height: 50px;
                top: 0px;
                background-color: #fff;
                left: 0px;
                width: 0px;
              "
            ></div>

            <!-- Rotation -->
            <div
              v-for="rota in employee.rotas"
              :key="rota.id + 'rota'"
              class="rotation"
              v-bind:style="[
                {
                  left: rota.rota_left + 'px',
                  width: rota.rota_width + 'px',
                  background: customPlanShiftColorEnabled ? customPlanShiftColor : ''
                },
                GetTimeBarHeight('outer')
              ]"
            ></div>
            <!-- Legal Pause Underage -->
            <div
              v-for="rota in employee.rotas"
              :key="'p' + rota.id"
              class="rotation"
              style="background-color: #d9d9d9"
              v-bind:style="[
                {
                  left: rota.pauseLegal_left + 'px',
                  width: rota.pauseLegal_width + 'px',
                  background: !employee.not_logged_in && employee.additionalPauseMandatory && !loadingPauses ? legalPauseErrorColor : customLegalPauseColorEnabled ? customLegalPauseColor : defaultLegalPauseColor,
                  opacity: !employee.not_logged_in && employee.additionalPauseMandatory && !loadingPauses ? (timestamp % 2 === 0 ? 1 : 0.3) : ''
                },
                GetTimeBarHeight('outer')
              ]"
            ></div>
            <!-- Spot Color -->
            <div
              v-for="rota in employee.rotas"
              :key="rota.id + 'rotaColorOverlay'"
              class="rotation"
              v-bind:style="[
                {
                  left: rota.rota_left + 'px',
                  width: rota.rota_width + 'px',
                  background: spotPlanShiftColorEnabled ? position.color : '',
                  opacity: spotPlanShiftColorEnabled ? 0.15 : 0
                },
                GetTimeBarHeight('outer')
              ]"
            ></div>
            <!-- Planpause -->
            <div
              v-for="pause in employee.rotas.filter((s) => s.planPauseStart)"
              :key="'plannedPause' + pause.id"
              class="rotation"
              v-bind:style="[
                {
                  left: (pause.planPauseStart > lowerBound ? pause.planPauseStart - lowerBound : 0) * secondPerPixel + 'px',
                  width: (pause.planPauseStart > lowerBound ? pause.planPauseDuration : pause.planPauseStart - lowerBound + pause.planPauseDuration) * secondPerPixel + 'px',
                  background: 'rgba(0,0,0,.55)',
                  opacity: spotPlanShiftColorEnabled ? 0.55 : 0.55
                },
                GetTimeBarHeight('outer')
              ]"
            ></div>

            <!-- ActualShift -->
            <div
              v-for="shift in employee.shifts"
              :key="'shift:' + shift.id"
              class="shift"
              v-bind:style="[
                {
                  left: shift.shift_left + 'px',
                  width: shift.shift_width + 'px',
                  opacity: EmployeeActualShiftNotStarted(employee) ? actualShiftNotStartedOpacity : '',
                  background: spotActualShiftColorEnabled ? position.color : ''
                },
                GetTimeBarHeight('inner')
              ]"
            >
              <div class="start" v-bind:style="[{ color: shift.shift_left === 0 ? 'transparent' : '' }, GetIconSize()]">
                {{ shift.start_hr }}
              </div>
              <div
                class="end"
                v-bind:style="[
                  {
                    color: !shift.end ? 'transparent' : '',
                    right: '-' + GetShiftOvertime(employee, shift).width
                  },
                  GetIconSize()
                ]"
              >
                {{ shift.end_hr }}
              </div>
              <div class="shift-overtime" v-bind:style="GetShiftOvertime(employee, shift)"></div>
            </div>

            <!-- Überstunden -->
            <div
              v-for="overtime in employee.overtimes"
              :key="'overtime:' + overtime.id"
              style="
                position: relative;
                height: 35px;
                margin-top: -35px;
                background-color: rgb(182, 20, 66);
              "
              v-bind:style="[
                {
                  left: overtime.overtime_left + 'px',
                  width: overtime.overtime_width + 'px'
                },
                GetTimeBarHeight('inner')
              ]"
            ></div>
            <!-- PAUSE -->
            <div
              v-for="pause in employee.pauses"
              :key="'pause:' + pause.id"
              class="pause"
              v-bind:style="[
                {
                  left: pause.pause_left + 'px',
                  width: pause.pause_width + 'px'
                },
                GetTimeBarHeight('inner')
              ]"
            >
              <i v-if="pause.duration >= 1800 && pause.pause_left > 5" v-bind:style="[GetPauseIconSize()]" v-bind:class="[pause.duration >= 30 * 60 ? 'fas fa-utensils' : 'fas fa-coffee']"></i>
            </div>

            <div
              v-if="employee.birthday"
              class="rotation"
              style="
                text-align: center;
                border-radius: 500px;
                border: 1px solid #888;
              "
              v-bind:style="[
                {
                  left: '3px',
                  'margin-top': '0px',
                  width: (GetTimeBarHeightValue('outer') / 10) * 8 + 'px',
                  background: '#e0e0e0',
                  'line-height': (GetTimeBarHeightValue('outer') / 10) * 8 + 'px',
                  height: (GetTimeBarHeightValue('outer') / 10) * 8 + 'px'
                }
              ]"
            >
              <i class="fas fa-birthday-cake fa-lg" style="text-align: center; color: #5c5c5c" v-bind:style="[GetIconSize()]"></i>
            </div>


            
            <div
              v-for="rota in employee.rotas.filter((rota) => showRestingArea && rota.legalPauseRest11_show && employee.shifts.length > 0)"
              :key="rota.id + 'rotaLegalPauseArea'"
              class="rotation stripes legalRest11"
              v-bind:style="[
                {
                  left: rota.legalPauseRest11_left + 'px',
                  width: rota.legalPauseRest11_width + 'px',
                  'line-height': (GetTimeBarHeightValue('outer') /8) * 8 + 'px',
                },
                GetTimeBarHeight('outer'),
              ]"
            ></div>
            
            <div
              v-for="rota in employee.rotas.filter((rota) => showRestingArea && rota.legalPauseRest11_show && employee.shifts.length > 0)"
              :key="rota.id + 'rotaLegalPauseLabel'"
              style="background-color:#555; text-align:center;"
              class="rotation legalRest11"
              v-bind:style="[
                {
                  left: (rota.legalPauseRest11_left + 10) + 'px',
                  width: (rota.legalPauseRest11_width/3) + 'px',
                  'line-height': (GetTimeBarHeightValue('outer') /20) * 8 + 'px',
                  'height': (GetTimeBarHeightValue('outer') /20) * 8 + 'px',
                },
              ]"
            >{{ $t('rest.elevenHours') }}</div>




            <!-- White Background cause the following div laying on top has a transparency -->
            <!--<div v-if="(employee.not_logged_in && employee.notLoggedInMinutes <= 45) || employee.not_logged_out || (!employee.not_logged_in && employee.additionalPauseMandatory && !loadingPauses)" style="position: relative; height: 50px; margin-top:-50px; background-color: #fff; z-index: 9998; left:4px;width:300px;"></div>-->
            <div
              v-if="(employee.not_logged_in && employee.notLoggedInMinutes <= 45) || employee.not_logged_out || (false && !employee.not_logged_in && employee.additionalPauseMandatory && !loadingPauses)"
              style="
                position: relative;
                height: 100%;
                margin-top: -50px;
                z-index: 9999;
                left: 4px;
                width: 300px;
              "
              v-bind:style="[
                { 'background-color': '#da2055' },
                {
                  left: GetRedBarLeft(employee),
                  width: GetRedBarWidth(employee)
                }
              ]"
            >
              <div style="width: 300px; height: 50px; overflow-y: hidden">
                <div
                  class="alertMessageIcon"
                  v-bind:style="[
                    {
                      opacity: alertIconOpacity,
                      display: !employee.not_logged_in && employee.additionalPauseMandatory && !loadingPauses ? 'none' : 'flex'
                    },
                    GetTimeBarIcon()
                  ]"
                  style="
                    position: absolute;
                    left: 5px;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                    height: 20px;
                    width: 20px;
                    font-size: 20px;
                    overflow-y: hidden;
                    background-color: #fff !important;
                    text-align: center;
                    border-radius: 20px;
                    color: #da2055 !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <strong style="margin-top: -3px">!</strong>
                </div>
                <div
                  v-if="employee.not_logged_in && employee.notLoggedInMinutes <= 45"
                  style="
                    text-align: center;
                    display: inline-block;
                    height: 100%;
                    width: max-content;
                    padding-left: 15px;
                    letter-spacing: 1px;
                    font-size: 19px;
                    overflow-y: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    line-height: 0;
                    color: #da2055;
                    position: absolute;
                  "
                  v-bind:style="[GetTimeBarText(), { left: GetRedBarTextLeft(employee) }]"
                >
                  <strong
                    style="
                      text-shadow: 1px 1px 2px #fff, 0 0 25px #fff, 0 0 5px #fff;
                    "
                    >{{ $t('alerts.late') }}
                    <!-- &bull; {{ employee.notLoggedInMinutes}} <small>min</small>-->
                  </strong>
                </div>
                <div
                  v-if="employee.not_logged_out"
                  style="
                    text-align: center;
                    display: inline-block;
                    height: 100%;
                    width: max-content;
                    padding-left: 15px;
                    letter-spacing: 1px;
                    font-size: 19px;
                    overflow-y: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    line-height: 0;
                    color: #da2055;
                    position: absolute;
                  "
                  v-bind:style="[GetTimeBarText(), { left: GetRedBarTextLeft(employee) }]"
                >
                  <strong>{{ $t('alerts.overtime') }} &bull; {{ employee.overtimeMinutes }} <small>{{ $t('units.minutesShort') }}</small></strong>
                </div>

                <div
                  v-if="false && !employee.not_logged_in && employee.additionalPauseMandatory && !loadingPauses"
                  style="
                    text-align: center;
                    display: inline-block;
                    height: 100%;
                    width: max-content;
                    padding-left: 15px;
                    letter-spacing: 1px;
                    font-size: 19px;
                    overflow-y: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    line-height: 0;
                    color: #da2055;
                    position: absolute;
                  "
                  v-bind:style="[GetTimeBarText(), { left: GetRedBarTextLeft(employee) }]"
                >
                  <strong>{{ $t('alerts.gotoBreak') }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="linesMiddleHourDiv" v-bind:style="[{ 'margin-left': line.leftHalf + 'px', width: oneHourWidth + 'px' }, GetGridTop()]" v-for="line in (MAINTENANCE ? [] : verticalLinesHours)" :key="'divMiddleHour' + line.id">
      {{ line.hourCode }}
    </div>

<div class="linesMiddleHourDiv"
  v-bind:style="[
    {
      'margin-left': line.leftHalf + (oneHourWidth / 2) + 'px',
      width: oneHourWidth + 'px',
      'flex-direction': 'column',
      'row-gap': '2px',
      'line-height': '1.3'
    },
    GetGridTopKPI()
  ]"
  v-for="line in (!MAINTENANCE && showKPIs ? verticalLinesHours : [])"
  :key="'divMiddleHourKPI' + line.id">

<span :style="{ color: kpiPlanColor, 'font-weight': 'bold', 'letter-spacing': '0.2px', 'font-size': '11px' }">
  {{ GetHourKPIPlanSum(line) }}
</span>
<span v-if="line.showActualKPI"
      :style="{ color: kpiActualColor, 'font-weight': 'bold', 'letter-spacing': '0.2px', 'font-size': '11px' }">
  {{ GetHourKPIActualSum(line) }}
</span>
  <span v-else
        style="color: #874E22; font-weight: bold; letter-spacing: 0.2px; font-size: 11px;">
    &nbsp;
  </span>

</div>


    <div
      class="linesMiddle"
      style="z-index: 4"
      v-bind:style="[
        {
          'margin-left': line.left + 'px',
          display: showHourlyDivisions ? '' : 'none',
          'z-index': showHourlyDivisionsOverBars ? '4 !important' : ''
        },
        GetGridTop()
      ]"
      v-for="line in (MAINTENANCE ? [] : verticalLines)"
      :key="line.id"
    ></div>
    <div v-if="!MAINTENANCE" class="lineLeft" v-bind:style="[GetGridTop()]"></div>
    <div v-if="!MAINTENANCE" class="lineRight" v-bind:style="[GetGridTop()]"></div>

    <div v-if="!MAINTENANCE" class="timeLine" v-bind:style="{ left: showPauses ? '105px' : '305px' }"></div>
    <div v-if="!MAINTENANCE" class="timeDiv" v-bind:style="{ left: showPauses ? '107px' : '307px' }">{{ clockHH }}<span class="timeDoublePoint" v-bind:style="{ opacity: timeDoublePointOpacity }">:</span>{{ clockMM }}</div>

    <div class="pause-container" v-if="!MAINTENANCE && currentPauses.length > 0" v-bind:style="[GetGridTop()]">
      <div class="header">{{ $t('pause.header') }}</div>
      <div class="pauses">
        <div class="employee-pause" v-for="pause in currentPauses" :key="'pause-card:' + pause.employee.employee_id + ':' + pause.pause.id">
          <div class="circle">
            <div class="cover-left" v-bind:style="GetPauseCover(1 - (timestamp + timeZoneShift - pause.pause.start) / pause.pause.duration, 'left', pause.pause)"></div>
            <div class="cover-mid"></div>
            <div class="cover-right" v-bind:style="GetPauseCover(1 - (timestamp + timeZoneShift - pause.pause.start) / pause.pause.duration, 'right', pause.pause)"></div>
          </div>
          <div class="timer fixed"></div>
          <div class="timer" v-bind:style="{ opacity: showPausePicture ? 0 : 1 }">
            {{ GetPauseTimerText(pause) }}
          </div>
          <div
            class="picture"
            v-bind:style="{
              opacity: showPausePicture ? 1 : 0,
              background: 'url(' + GetProfilePicture(pause.employee) + ')',
              'background-size': '90px 90px',
              'background-repeat': 'no-repeat'
            }"
          ></div>
          <div
            class="icon fas"
            v-bind:class="{
              'fa-coffee': pause.pause.duration < 60 * 30,
              'fa-utensils': pause.pause.duration >= 60 * 30
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { createPausenplanApi } from "../services/pausenplanApi";
import { createRefreshController } from "../services/refreshController";
import { optionState, displayPositions, currentPauses } from "../utils/pausenplanSnapshot";
import { getEmployeesForPosition } from "../utils/pausenplanDisplay";
import { pausenplanHealth } from "../utils/pausenplanHealth";
export default {
  name: "Pausenplan",
  props: {},
  data: function() {
    return {
      MAINTENANCE: false,

      pausenplanId: "",
      pausenplanToken: "",
      publicPausenplanId: "",
      publicPausenplanToken: "",
      storeId: 33,
      pausenplanIdentifier: "",

      showIdentify: false,
      showIdentifyTime: 0,

      timestamp: 0,
      timestampOffset: 0,
      positions: [],
      positionsOriginal: [],
      rotas: [],
      hiddenRotas: [],
      shifts: [],
      pauses: [],
      employees: [],

      customPositions: [],

      employeeMap: {},

      timeDoublePointOpacity: 1,
      alertIconOpacity: 1,

      timeframe: 17,
      lowerBound: 0,
      upperBound: 0,

      verticalLines: [],
      verticalLinesHours: [],

      timelinesWidth: 0,
      secondPerPixel: 0,
      oneHourWidth: 0,

      showRestingArea: true,
      showFinished: true,
      showKPIs: false,
      hideFinishedWhichAreOlderThanHours: 5,
      showFuture: 0,

      headerPadding: 100,

      randomFirstnames: ["Mia", "Emilia", "Sophia", "Hanna", "Emma", "Lina", "Mila", "Lea", "Marie", "Ella", "Louisa", "Klara", "Amelie", "Frida", "Emilie", "Ida", "Leonie", "Lya", "Matilda", "Sofie", "Anna", "Lena", "Charlotte", "Johanna", "Leni"],
      randomLastnames: ["Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Neumann", "Schwarz", "Zimmermann", "Braun", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause"],

      showPauses: false,
      rowHeightDefault: 50,

      rowHeightMax: 75,
      rowHeightMin: 20,
      rowHeightCurrent: 50,
      timeBarMargin: 8,
      timeBarPadding: 26,
      employeePadding: 5,
      currentPauses: [],
      hourlyPlanShiftSums:   {},   // { [hourStartUnix]: hours }  aus rotas
      hourlyActualShiftSums: {},   // { [hourStartUnix]: hours }  aus shifts

      staleOpenShiftMaxHours: 16,
      staleOpenShiftAfterPlanHours: 6,

      timeZoneShift: 0, //(new Date().getTimezoneOffset() * 60)

      actualShiftEndedOpacity: 0.6,
      actualShiftNotStartedOpacity: 0.6,

      showHourlyDivisions: true,
      showHourlyDivisionsOverBars: false,

      usePositions: true,
      showDefaultPause: false,
      countryId: 1,

      spotActualShiftColorEnabled: true,
      spotPlanShiftColorEnabled: true,

      customPlanShiftColorEnabled: false,
      customPlanShiftColor: "#202265",

      customPlannedPauseColorEnabled: false,
      customPlannedPauseColor: "#30c321",

      defaultLegalPauseColor: "#bababa",
      customLegalPauseColor: "#1030c3",
      customLegalPauseColorEnabled: false,
      legalPauseErrorColor: "#da2055",

      loadingPauses: true,
      pauseCallbackReceived: false,

      customActualColor: "#2ac3b5",
      kpiPlanColor:   "#546827",
      kpiActualColor: "#a35d10",

    };
  },
  created() {
    this._runtime = { timers: new Set(), subscriptions: [], disposed: false };
    this._snapshot = null;
  },
  updated() {
    pausenplanHealth.updated();
  },
  beforeDestroy() {
    this._runtime.disposed = true;
    this._runtime.timers.forEach(timer => clearTimeout(timer));
    this._runtime.timers.clear();
    if (this._refresh) this._refresh.dispose();
    if (this._maintenanceCancel) this._maintenanceCancel.cancel();
    if (this._unwatchContext) this._unwatchContext();
    this.clearSubscriptions();
    if (this._socket && this._onConnect) this._socket.off("connect", this._onConnect);
    document.removeEventListener("visibilitychange", this._onVisibility);
    pausenplanHealth.stop();
  },
  computed: {
    /*
        content: function () {
            let pages = [];
        },*/
    clockHH: function() {
      let date = moment.unix(this.timestamp);
      return date.format("HH");
    },
    // Pause container switches hard between remaining time and profile picture every 5 seconds
    showPausePicture: function() {
      return Math.floor(this.timestamp / 5) % 2 === 1;
    },
    clockMM: function() {
      let date = moment.unix(this.timestamp);
      return date.format("mm");
    }
  },
  mounted() {
    const url = new URL(window.location.href);
    this.pausenplanId = url.searchParams.get("id");
    this.pausenplanToken = url.searchParams.get("token");
    this.publicPausenplanId = url.searchParams.get("publicId");
    this.publicPausenplanToken = url.searchParams.get("publicToken");
    this.timestamp = moment().unix();
    pausenplanHealth.start();
    this._onVisibility = () => pausenplanHealth.visibility(document.visibilityState === "visible");
    this._onVisibility();
    document.addEventListener("visibilitychange", this._onVisibility);
    this.setupRefreshContext();
    this._unwatchContext = this.$watch(
      () => JSON.stringify([this.pausenplanId, this.pausenplanToken, this.publicPausenplanId, this.publicPausenplanToken]),
      () => this.setupRefreshContext()
    );
    this._socket = window.Echo && window.Echo.connector && window.Echo.connector.socket;
    this._onConnect = () => this.requestRefresh();
    if (this._socket) this._socket.on("connect", this._onConnect);
    this.startTimer(() => {
      this.timestamp = moment().unix();
      this.timeDoublePointOpacity = this.timeDoublePointOpacity === 1 ? 0.5 : 1;
      this.alertIconOpacity = this.timeDoublePointOpacity === 1 ? 1 : 0.2;
      this.refreshCurrentPauses();
      this.showIdentifyTime = Math.max(0, this.showIdentifyTime - 1000);
      if (!this.showIdentifyTime) this.showIdentify = false;
    }, 1000);
    this.startTimer(() => { this.alertIconOpacity = this.alertIconOpacity === 1 ? 0.2 : 1; }, 3000);
    this.startTimer(() => this.rebuildDisplay(), 25000);
    this.startTimer(() => this.rebuildDisplay(), 30000);
    this.startTimer(() => pausenplanHealth.check(), 5000);
    this._maintenanceCancel = axios.CancelToken.source();
    axios.get("/api/isMaintenance", { timeout: 15000, cancelToken: this._maintenanceCancel.token })
      .then(response => {
        if (!this._runtime.disposed) this.MAINTENANCE = response.data && response.data.message === "true";
      }).catch(() => {
        if (!this._runtime.disposed) pausenplanHealth.record("request-error", "maintenance");
      });
  },
  methods: {
    EmployeeShiftEnded(employee) {
      let view = this;
      let stillRunning = employee.shifts.find((s) => s.show && s.start && s.start < view.timestamp && s.end == null);
      if (stillRunning) return false;
      let find = employee.shifts.find((s) => s.show && s.end && s.end < view.timestamp);
      if (!find) find = employee.rotas.find((s) => s.show && s.end && s.end < view.timestamp);
      return find;
    },
    EmployeeActualShiftNotStarted(employee) {
      let view = this;
      return employee.shifts.find((s) => s.show && s.shift_start && s.shift_start > view.timestamp);
    },
    GetShiftOvertime(employee, shift) {
      let view = this;
      let rota = employee.rotas.find((r) => r.show && r.rota_start < view.timestamp);
      if (rota && shift.end && shift.end > rota.end) {
        return {
          right: 0 + "px",
          width: (shift.shift_end - rota.rota_end) * view.secondPerPixel + "px"
        };
      }
      return { display: "none" };
    },
    GetPauseCover(pauseLeft, side, pause) {
      if (side === "left") {
        if (pauseLeft < 0.5)
          return {
            transform: "rotate(" + (-360 + 360 * (0.5 - pauseLeft)) + "deg) translate(-50%, 0%)"
          };
        else return { transform: "translate(-50%, 0%)" };
      } else {
        return {
          display: pauseLeft < 0.5 ? "none" : "",
          transform: "rotate(" + 360 * (1 - pauseLeft) + "deg) translate(50%, 0%)"
        };
      }
    },
    hexToHSLObject(H) {
      let r = 0,
        g = 0,
        b = 0;
      if (H.length === 4) {
        r = "0x" + H[1] + H[1];
        g = "0x" + H[2] + H[2];
        b = "0x" + H[3] + H[3];
      } else if (H.length === 7) {
        r = "0x" + H[1] + H[2];
        g = "0x" + H[3] + H[4];
        b = "0x" + H[5] + H[6];
      }
      r /= 255;
      g /= 255;
      b /= 255;
      let cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

      if (delta === 0) h = 0;
      else if (cmax === r) h = ((g - b) / delta) % 6;
      else if (cmax === g) h = (b - r) / delta + 2;
      else h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      if (h < 0) h += 360;

      l = (cmax + cmin) / 2;
      s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);

      return { h: h, s: s, l: l };
    },
    GetContrastingColor(hex, lightcolor = "white", darkcolor = "#404040", contrastLimit = 70) {
      if (!hex) return darkcolor;
      let hsl = this.hexToHSLObject(hex);
      if (hsl.l < contrastLimit) return lightcolor;
      else return darkcolor;
    },
    GetPositionName(position) {
      if (position.name == null) return "";
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (50 * 1.5);
      let employees = position.employees.filter((e) => e.show);
      let letterWidth = 7;
      let positionHeight = employees.length * this.rowHeightCurrent * reductionRatio;
      if (position.name.length * letterWidth > positionHeight - 5) {
        return position.name.substr(0, parseInt((positionHeight - 5) / letterWidth) + 1);
      }
      return position.name;
    },

    GetGridTop() {
      return { transform: "translateY(" + (this.headerPadding - 80) + "px)" };
    },
    GetGridTopKPI() {
      return { transform: "translateY(" + (this.headerPadding - 120) + "px)" };
    },
    showPosition: function(position) {
      if (!position.active) return false;
      let employees = position.employees;
      for (let i in employees) {
        let employee = employees[i];
        if (employee.show) return true;
      }
      return false;
    },

    calculateTimeLines: function() {
      let view = this;
      view.verticalLines = [];
      view.verticalLinesHours = [];
      view.lowerBound = view.timestamp - (view.timeframe * 3600) / 2;
      view.upperBound = view.timestamp + (view.timeframe * 3600) / 2;

      let tmp = moment.unix(view.lowerBound);
      let timestamp = view.lowerBound + (60 - tmp.minutes()) * 60 - tmp.seconds();

      let lineStart = timestamp;
      let id = 0;
      while (lineStart < view.upperBound) {
        let date = moment.unix(lineStart);
        let isPastHour = (lineStart + 3600) <= (view.timestamp + view.timeZoneShift);
        let obj = {
          id: id,
          moment: moment.unix(timestamp),
          hourStart: lineStart,
          showActualKPI: isPastHour,
          left: (lineStart - view.lowerBound) * view.secondPerPixel,
          leftHalf: (lineStart - view.lowerBound) * view.secondPerPixel - view.oneHourWidth / 2,
          hourCode: date.format("HH") + ":00"
        };
        if (lineStart > view.timestamp - 4000 && lineStart < view.timestamp + 4000) {
          obj.hourCode = "";
        }
        view.verticalLines.push(obj);
        view.verticalLinesHours.push(obj);
        lineStart = lineStart + 3600;
        id++;
      }
    },
    GetHourKPISum(line) {
      if (!line || line.hourStart == null) return "";
      let sum = this.hourlyShiftSums[line.hourStart];
      if (sum === undefined || sum === null) return "0.00 h";
      return sum.toFixed(2) + " h";
    },

    // ---------------------------------------------------------------
    // Generischer Helfer: verteilt beliebige { start, end }-Intervalle
    // sekundengenau auf ganze Stunden-Slots.
    // Rückgabe: { [hourStartUnix]: hours, mit 2 Dezimalen }
    // ---------------------------------------------------------------
    calculateHourlySums(items) {
      let sums = {};
      if (!items || !items.length) return {};

      for (let i in items) {
        let item = items[i];
        if (!item || item.start == null || item.end == null) continue;
        let start = item.start;
        let end   = item.end;
        if (end <= start) continue;

        let hourStart = Math.floor(start / 3600) * 3600;
        while (hourStart < end) {
          let hourEnd = hourStart + 3600;
          let overlap = Math.min(end, hourEnd) - Math.max(start, hourStart);
          if (overlap > 0) {
            sums[hourStart] = (sums[hourStart] || 0) + overlap;
          }
          hourStart = hourEnd;
        }
      }

      let result = {};
      for (let k in sums) {
        result[k] = Math.round((sums[k] / 3600) * 100) / 100;
      }
      return result;
    },

    // ---------------------------------------------------------------
    // Wird einmalig nach dem Laden (und periodisch im Tick) aufgerufen
    // ---------------------------------------------------------------
    calculateHourlyKPISums() {
      let now = this.timestamp + this.timeZoneShift;

      // --- Plan-Schichten: 1:1 aus this.rotas (unverändert) ---
      let planItems = [];
      for (let i in this.rotas) {
        let r = this.rotas[i];
        if (!r || r.start == null || r.end == null) continue;
        planItems.push({ start: r.start, end: r.end });
      }
      this.hourlyPlanShiftSums = this.calculateHourlySums(planItems);

      // --- Actual-Schichten mit Forgotten-Logout-Filter ---
      let actualItems = [];
      let maxOpenSec      = this.staleOpenShiftMaxHours * 3600;
      let afterPlanSec    = this.staleOpenShiftAfterPlanHours * 3600;

      for (let i in this.shifts) {
        let s = this.shifts[i];
        if (!s || s.start == null) continue;

        // Abgeschlossen → immer zählen
        if (s.end != null) {
          if (s.end > s.start) actualItems.push({ start: s.start, end: s.end });
          continue;
        }

        // Offen → prüfen, ob vergessener Logout
        // A) absolute Dauer
        if (now - s.start > maxOpenSec) continue;

        // B) weit über geplantes Rota-Ende
        if (s.id_rota != null) {
          let rota = this.rotas.find(r => r.id === s.id_rota);
          if (rota && rota.end != null && (now - rota.end) > afterPlanSec) continue;
        }

        // läuft noch, gilt als echt
        actualItems.push({ start: s.start, end: now });
      }

      this.hourlyActualShiftSums = this.calculateHourlySums(actualItems);
    },

    // ---------------------------------------------------------------
    // Zwei dünne Lookups für das Template
    // ---------------------------------------------------------------
    GetHourKPIPlanSum(line) {
      if (!line || line.hourStart == null) return "";
      let v = this.hourlyPlanShiftSums[line.hourStart];
      return (v === undefined ? "0.00" : v.toFixed(2)) + "";
    },
    GetHourKPIActualSum(line) {
      if (!line || line.hourStart == null) return "";
      let v = this.hourlyActualShiftSums[line.hourStart];
      return (v === undefined ? "0.00" : v.toFixed(2)) + "";
    },
    GetPauseTimeRemainingText(pause) {
      if (!pause) return "";
      let timeRemaining = pause.duration - (this.timestamp + this.timeZoneShift - pause.start);
      let minutes = parseInt(timeRemaining / 60);
      let seconds = parseInt(timeRemaining % 60);
      if (seconds < 10) seconds = "0" + seconds;
      return "-" + minutes + ":" + seconds;
    },
    GetEmployeeFirstName: function(employee) {
      //return this.randomFirstnames[Math.floor(Math.random() * 25)];

      return this.employeeMap[employee.employee_id].firstname ? this.employeeMap[employee.employee_id].firstname : "";
    },
    GetEmployeeLastName: function(employee) {
      //return this.randomLastnames[Math.floor(Math.random() * 25)];
      return this.employeeMap[employee.employee_id].lastname ? this.employeeMap[employee.employee_id].lastname : "";
    },
    GetProfilePicture: function(employee) {
      //return "https://fileserver1.meindienstplan.de/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S";
      if (!this.employeeMap[employee.employee_id].profile_picture_storageServerId) return "/images/avatar.png";
      return "https://fileserver1.meindienstplan.de/api/file?id=" + this.employeeMap[employee.employee_id].profile_picture_storageServerId + "&accessToken=" + this.employeeMap[employee.employee_id].profile_picture_storageServerAccessToken;
    },
    GetPauseTimerText(pauseContainer) {
      let timeString = this.GetPauseTimeRemainingText(this.GetEmployeePauseCurrent(pauseContainer.employee));
      if (timeString.split(":")[0] === "-0") return timeString.split(":")[1];
      return timeString.split(":")[0].replace("-", "");
    },
    GetExternMarkerStyle() {
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);
      let size = this.rowHeightCurrent - this.employeePadding * 2 + -8 + "px";
      if (this.rowHeightCurrent >= 35) {
        return {
          height: 20 * reductionRatio + "px",
          width: 20 * reductionRatio + "px",
          top: 17 * reductionRatio + "px",
          "margin-left": "-25px",
          border: "2px solid white"
        };
      } else {
        return {
          height: 20 * reductionRatio + "px",
          width: 20 * reductionRatio + "px",
          top: 17 * reductionRatio + "px",
          "margin-left": "-25px",
          border: "2px solid white"
        };
      }
    },
    GetExternMarkerIconStyle() {
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);

      let size = this.rowHeightCurrent - this.employeePadding * 2 - 10 + "px";
      let lH = this.rowHeightCurrent - this.employeePadding * 2 - 16 + "px";

      if (this.rowHeightCurrent >= 35) {
        return {
          height: 17 * reductionRatio + "px",
          "line-height": 17 * reductionRatio + "px",
          width: 17 * reductionRatio + "px",
          "font-size": 12 * reductionRatio + "px"
        };
      } else {
        return {
          height: 17 * reductionRatio + "px",
          "line-height": 17 * reductionRatio + "px",
          width: 17 * reductionRatio + "px",
          "font-size": 8 * reductionRatio + "px"
        };
      }
    },
    GetEmployeePictureStyle() {
      let size = this.rowHeightCurrent - this.employeePadding * 2 + "px";
      if (this.rowHeightCurrent >= 25) return { height: size, width: size };
      return { display: "none" };
    },
    GetEmployeeNameStyle(type) {
      if (this.rowHeightCurrent < 35)
        return {
          position: "relative",
          margin: "initial",
          left: 0,
          "margin-right": "5px"
        };
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);
      let style = { "font-size": 14 * reductionRatio + "px" };
      if (type === "first") style["margin-top"] = 6 * reductionRatio + "px";
      if (type === "last") style["margin-bottom"] = 6 * reductionRatio + "px";
      return style;
    },
    GetIconSize(inverse) {
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);
      if (inverse) reductionRatio = 1 / reductionRatio;
      return { transform: "scale(" + reductionRatio + ")" };
    },
    GetEmployeePauseCurrent(employee) {
      let view = this;
      let pause = employee.pauses.find((p) => p.start < view.timestamp + view.timeZoneShift && p.start + p.duration > view.timestamp + view.timeZoneShift);
      /*if(pause) {
                view.currentPauses = view.currentPauses.filter(p => !(p.pause.start < view.timestamp && (p.pause.start + (p.pause.duration)) > view.timestamp));
                if(!view.currentPauses.find(p => p.pause === p)) view.currentPauses.push({employee: employee, pause: pause});
            }*/
      return pause;
    },
    GetTimeBarHeight(type) {
      let reductionRatio = this.rowHeightCurrent / this.rowHeightDefault;
      //            if(type === 'bar') return {height: (this.rowHeightCurrent) + 'px'}
      let margin = Math.ceil(this.timeBarMargin * reductionRatio);
      if (type === "bar") return { height: this.rowHeightCurrent - margin + "px" };
      let padding = Math.ceil(this.timeBarPadding * reductionRatio);
      if (type === "outer") return { height: this.rowHeightCurrent - 0 + "px" };
      if (type === "inner") return { height: this.rowHeightCurrent - padding + "px" };
    },
    GetTimeBarHeightValue(type) {
      let reductionRatio = this.rowHeightCurrent / this.rowHeightDefault;
      //            if(type === 'bar') return {height: (this.rowHeightCurrent) + 'px'}
      let margin = Math.ceil(this.timeBarMargin * reductionRatio);
      if (type === "bar") return this.rowHeightCurrent - margin;
      let padding = Math.ceil(this.timeBarPadding * reductionRatio);
      if (type === "outer") return this.rowHeightCurrent - 0;
      if (type === "inner") return this.rowHeightCurrent - padding;
    },
    GetTimeBarText() {
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);
      //            if(type === 'bar') return {height: (this.rowHeight) + 'px'}
      return { "font-size": 17 * reductionRatio + "px" };
    },
    GetRedBarLeft(employee) {
      if (((employee.not_logged_in && employee.notLoggedInMinutes <= 45) || (!employee.not_logged_in && employee.additionalPauseMandatory && !this.loadingPauses)) && employee.rotas.filter((r) => r.show)[0]) {
        let midPoint = this.timeframe * 0.5 * 3600 * this.secondPerPixel;
        if (midPoint - employee.rotas[0].rota_left > 30) return employee.rotas.filter((r) => r.show)[0].rota_left + "px";
        else return midPoint - 30 + "px";
      }
      return "";
    },
    GetRedBarWidth(employee) {
      if (((employee.not_logged_in && employee.notLoggedInMinutes <= 45) || (!employee.not_logged_in && employee.additionalPauseMandatory && !this.loadingPauses)) && employee.rotas.filter((r) => r.show)[0]) {
        let midPoint = this.timeframe * 0.5 * 3600 * this.secondPerPixel;
        if (midPoint - employee.rotas[0].rota_left > 30) return (this.timestamp - employee.rotas.filter((r) => r.show)[0].rota_start) * this.secondPerPixel + "px";
        else return 30 + "px";
      }
      return "30px";
    },
    GetRedBarTextLeft(employee) {
      if (((employee.not_logged_in && employee.notLoggedInMinutes <= 45) || (!employee.not_logged_in && employee.additionalPauseMandatory && !this.loadingPauses)) && employee.rotas.filter((r) => r.show)[0]) {
        let midPoint = this.timeframe * 0.5 * 3600 * this.secondPerPixel;
        if (midPoint - employee.rotas[0].rota_left > 30) return (this.timestamp - employee.rotas.filter((r) => r.show)[0].rota_start) * this.secondPerPixel + "px";
        else return 30 + "px";
      }
      return "30px";
    },
    GetTimeBarIcon() {
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);
      //            if(type === 'bar') return {height: (this.rowHeight) + 'px'}
      return { "font-size": 24 * reductionRatio + "px" };
    },
    GetPauseIconSize() {
      let reductionRatio = 1 / 3 + this.rowHeightCurrent / (this.rowHeightDefault * 1.5);
      //            if(type === 'bar') return {height: (this.rowHeight) + 'px'}
      return { "font-size": 16 * reductionRatio + "px" };
    },
    GetEmployeeNameMargin() {
      let size = this.rowHeightCurrent - this.employeePadding * 2;
      return { left: size + this.employeePadding * 2 + "px" };
    },
    startTimer(callback, delay) {
      const run = () => {
        this._runtime.timers.delete(timer);
        if (this._runtime.disposed) return;
        try { callback(); }
        catch (error) { pausenplanHealth.record("timer-error", error.message); }
        finally {
          if (!this._runtime.disposed) {
            timer = setTimeout(run, delay);
            this._runtime.timers.add(timer);
          }
        }
      };
      let timer = setTimeout(run, delay);
      this._runtime.timers.add(timer);
    },
    clearSubscriptions() {
      this._runtime.subscriptions.forEach(({ channel, event, callback }) => channel.stopListening(event, callback));
      this._runtime.subscriptions = [];
    },
    subscribeChannel(name, event, callback) {
      if (!window.Echo) return;
      const channel = window.Echo.channel(name);
      channel.listen(event, callback);
      this._runtime.subscriptions.push({ channel, event, callback });
    },
    setupRefreshContext() {
      if (this._refresh) this._refresh.dispose();
      this.clearSubscriptions();
      this._snapshot = null;
      Object.assign(this, { positions: [], employees: [], employeeMap: {}, rotas: [], shifts: [], pauses: [], currentPauses: [] });
      const auth = { id: this.pausenplanId, token: this.pausenplanToken, publicId: this.publicPausenplanId, publicToken: this.publicPausenplanToken };
      const api = createPausenplanApi();
      this._refresh = createRefreshController({
        load: registerAbort => api.load(auth, registerAbort),
        commit: snapshot => this.applySnapshot(snapshot),
        onError: error => pausenplanHealth.record("request-error", "snapshot discarded; retry scheduled: " + error.message)
      });
      this.subscribeChannel("maintenance", "MaintenanceEvent", () => window.location.reload());
      const handleNotification = event => {
        if (event && event.data && event.data.model === "identify") {
          this.showIdentify = true;
          this.showIdentifyTime = 15000;
        } else {
          this.requestRefresh();
        }
      };
      if (auth.id && auth.token) this.subscribeChannel("pausenplan." + auth.id + "." + auth.token, "PausenplanNotificationEvent", handleNotification);
      else if (auth.publicId && auth.publicToken) this.subscribeChannel("pausenplan." + auth.publicId + "." + auth.publicToken, "PausenplanNotificationEvent", handleNotification);
      this.requestRefresh();
    },
    requestRefresh() {
      return this._refresh ? this._refresh.requestRefresh() : Promise.resolve();
    },
    prepareDisplay(snapshot) {
      const state = { ...this.$data, ...optionState(snapshot.options),
        employees: snapshot.employees, rotas: snapshot.rotas, shifts: snapshot.shifts,
        hiddenRotas: snapshot.hiddenRotas, pauses: snapshot.pauses,
        employeeMap: Object.create(null)
      };
      // Chromium 65 on older players does not provide Object.fromEntries.
      snapshot.employees.forEach(employee => { state.employeeMap[employee.id] = employee; });
      const locale = snapshot.options.locale;
      const translate = key => ['de', 'en', 'sl'].includes(locale) ? this.$i18n.t(key, locale) : this.$t(key);
      state.positions = displayPositions(snapshot, translate);
      const content = document.getElementById("content");
      state.timelinesWidth = Math.max(0, (content ? content.offsetWidth : window.innerWidth) - (state.showPauses ? 540 : 340));
      state.secondPerPixel = state.timelinesWidth / (state.timeframe * 3600);
      state.oneHourWidth = state.secondPerPixel * 3600;
      state.calculateTimeLines = this.$options.methods.calculateTimeLines;
      state.calculateHourlySums = this.$options.methods.calculateHourlySums;
      state.calculateTimeLines();
      const assigned = { rotas: new Set(), shifts: new Set() };
      state.positions.forEach(position => { position.employees = getEmployeesForPosition(state, position, assigned); });
      this.$options.methods.calculateHourlyKPISums.call(state);
      const count = state.positions.filter(position => position.active)
        .reduce((sum, position) => sum + position.employees.filter(employee => employee.show).length, 0);
      state.rowHeightCurrent = Math.max(state.rowHeightMin, Math.min(state.rowHeightMax, (window.innerHeight - 160) / Math.max(1, count)));
      state.currentPauses = currentPauses(state.positions, state.timestamp + state.timeZoneShift, Math.floor((window.innerHeight - 180) / 150));
      // Only publish data: helper functions remain outside Vue's reactive state.
      delete state.calculateTimeLines;
      delete state.calculateHourlySums;
      return state;
    },
    applySnapshot(snapshot) {
      const state = this.prepareDisplay(snapshot);
      this._snapshot = snapshot;
      if (['de', 'en', 'sl'].includes(snapshot.options.locale)) this.$i18n.locale = snapshot.options.locale;
      Object.assign(this, state, { loadingPauses: false, pauseCallbackReceived: true });
      pausenplanHealth.record("snapshot", "complete snapshot applied");
    },
    rebuildDisplay() {
      if (this._snapshot) Object.assign(this, this.prepareDisplay(this._snapshot));
    },
    refreshCurrentPauses() {
      this.currentPauses = currentPauses(this.positions, this.timestamp + this.timeZoneShift, Math.floor((window.innerHeight - 180) / 150));
    },

    componentToHex: function(c) {
      var hex = c.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    },
    rgbToHex: function(r, g, b) {
      return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },
    hexToRgb: function(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          }
        : null;
    }
  }
};
</script>

<style scoped>
.pausenplan {
  width: calc(100vw - 50px);
  position: relative;
  /* Keep negative-z-index grid lines above the white app background. */
  z-index: 2;
  height: 100vh;
}

.overlayMain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999998;
  background-color: rgba(33, 33, 33, 0.7);
}
.overlayText {
  z-index: 9999999;
  position: fixed;
  font-size: 256px;
  font-weight: bold;
  letter-spacing: 0px;
  height: 300px;
  line-height: 300px;
  margin-top: calc(50% - 300px);
  margin-left: calc(50% - 250px);
  width: 500px;
  color: #282828;
  text-shadow: 1px 1px 2px #fff, 0 0 25px #fff, 0 0 5px #fff, 0 0 55px #fff;
  text-align: center;
}

.content {
  width: calc(100% - var(--content-margin) * 2);
  width: calc(100vw - 30px);
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}
.header {
  width: 100%;
  height: var(--header-height);
  margin: 0;
  padding: 0;
  background-color: rgba(1, 110, 50, 0);
}

.position {
  position: relative;
  position: relative;
  padding-left: 0px;
  width: 100vw;
}
.position .outer:first-child {
  position: absolute;
  left: 290px;
  top: 0;
  height: 100%;
  width: 20px;
}

.position > .outer > .header {
  width: 20px;
  font-size: 12px;
  height: 100%;
  line-height: 30px;
  font-weight: bold;
  /*text-shadow: -2px 0 2px #444, 0 2px 2px #444, 2px 0 2px #444, 0 -2px 2px #444;*/
  color: #fff;
  letter-spacing: 1px;
  display: inline-block;
  overflow: hidden;
  font-family: DistrictProBook, Arial, Helvetica, sans-serif;
  position: absolute;
  writing-mode: vertical-rl;
  /* text-orientation: upright; */
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transform: rotate(180deg);
  z-index: 10;
  white-space: nowrap;
}

.position > .outer > .employee {
  width: 300px;
  /* margin-left: 15px; */
  font-size: 15px;
  height: 100%;
  background-color: #fff;
  margin: 0;
  padding: 0;
  z-index: 1;
  box-shadow: inset 0 1px 0 0 #e5e5e5;
}
.position > .outer > .employee > .bg {
  width: 250px;
  height: 100%;
  margin-left: 50px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  position: relative;
}

.lineLeft {
  position: absolute;
  top: calc(var(--content-margin) + var(--header-height) + 10px);
  left: calc(300px + var(--content-margin));
  border-left: 1px solid #e5e5e5;
  height: calc(100% - (var(--content-margin) * 2 + var(--header-height)));
  width: 0px;
  display: none;
}
.lineRight {
  position: absolute;
  top: calc(var(--content-margin) + var(--header-height) + 10px);
  right: -20px;
  border-left: 1px solid #e5e5e5;
  height: calc(100% - (var(--content-margin) * 2 + var(--header-height)));
  width: 0px;
}
.timeLine {
  position: absolute;
  top: calc(var(--content-margin) + var(--header-height) + 30px);
  left: 307px;
  right: 0;
  margin: auto;
  border-left: 3px solid #808080;
  border-right: 3px solid #808080;
  width: 0px;
  height: 100vh;
  z-index: 100;
}
.timeDiv {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: calc(var(--content-margin) + var(--header-height) - var(--header-hour-height) + 10px);
  left: 307px;
  right: 0;
  margin: auto;
  height: 40px;
  width: 200px;
  background-color: rgba(128, 128, 128, 0.9);
  text-align: center;
  line-height: calc(var(--header-height) - 10px);
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
  font-family: monospace;
  z-index: 10;
}
/* no opacity transition: it toggles every second and would keep the compositor rendering continuously on kiosk players */
.timeDoublePoint {
}

/* no opacity transition: it toggles every second and would keep the compositor rendering continuously on kiosk players */
.alertMessageIcon {
}

.linesMiddle,
.linesMiddleDiv,
.linesMiddleHourDiv {
  z-index: 1 !important;
}
.linesMiddle {
  position: absolute;
  top: calc(var(--content-margin) + var(--header-height));
  left: calc(300px + var(--content-margin));
  /*border-left: 1px solid #eee;
            border-right: 1px solid #eee;*/
  background-color: rgba(239, 239, 239, 0.5);
  height: calc(100% - (var(--content-margin) * 2 + var(--header-height)));
  width: 2px;
  z-index: -1 !important;
}

.linesMiddleDiv {
  position: absolute;
  margin-top: -20px;
  top: calc(var(--content-margin));
  left: calc(300px + var(--content-margin));
  height: calc(var(--header-height));
  text-align: center;
}
.linesMiddleHourDiv {
  position: absolute;
  top: calc(var(--content-margin) + var(--header-height) - var(--header-hour-height) - 10px);
  left: calc(300px + var(--content-margin));
  height: 40px;
  text-align: center;
  font-family: DistrictProBook;
  font-size: 12px;
  color: #808080;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content > .header {
  position: relative;
  top: 0;
  left: 0;
  padding-top: 150px;
  height: initial;
  margin-bottom: 30px;
}

.content > .header .header-image {
  position: absolute;
  bottom: 10px;
  left: 55px;
  width: 50px;
  height: 50px;
  overflow: hidden;
}

.content > .header .header-text {
  position: absolute;
  bottom: 10px;
  left: 115px;
  width: 177px;
  height: 50px;
  overflow: hidden;
}

.time-backdrop {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 40px;
  width: calc(100% - 290px);
}

.employee-column {
  height: 50px;
  position: relative;
}

.firstname {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50px;
  margin: auto;
  margin-top: 6px;
  font-family: DistrictProBook;
  font-size: 14px;
  height: fit-content;
  color: #404040;

  padding-left: 1px;
  white-space: nowrap;
}

.lastname {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50px;
  margin: auto;
  margin-bottom: 6px;
  font-family: DistrictProBold;
  font-size: 14px;
  height: fit-content;
  color: #404040;
  white-space: nowrap;
}

.name {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50px;
  margin: auto;
  font-family: DistrictProBook;
  font-size: 14px;
  height: fit-content;
  color: #404040;
  padding-left: 1px;
  white-space: nowrap;
}

.name .firstname,
.name .lastname {
  display: inline;
}

.timebar {
  display: inline-block;
  overflow: hidden;
  width: calc(100% - 315px);
  height: 40px;
  z-index: 1;
  background-color: transparent !important;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;

  margin-left: 10px;
}

.pause {
  background-color: rgb(229, 196, 31);
  text-align: center;
  color: white;
  text-align: left;
  /* padding-left: 5px; */
  position: absolute;
  height: 23px;
  top: 0;
  bottom: 0;
  font-size: 18px;
  float: left;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shift {
  position: absolute;
  height: 23px;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: #708d2b;
}

.shift .start,
.shift .end {
  position: absolute;
  z-index: 999;
  text-align: left;
  color: white;
  font-size: 14px;
  font-family: DistrictProBook;
  top: -1px;
  bottom: 0;
  margin: auto;
  height: fit-content;
  padding: 0 10px;
}

.shift .start {
  left: 3px;
}

.shift .end {
  right: 3px;
  text-align: right;
}

.rotation {
  position: absolute;
  height: 50px;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: #e5e5e5;
}

.legalcheck {
  position: absolute;
  height: 50px;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: #e5e5e5;
}

.pause,
.shift {
}

.shift-hour {
  position: absolute;
  z-index: 999;
  text-align: left;
  color: white;
  font-size: 14px;
  font-family: DistrictProBook;
  top: 0;
  bottom: 0;
  margin: auto;
  height: fit-content;
  padding-left: 10px;
}

.pause-container {
  position: absolute;
  right: 20px;
  top: calc(var(--content-margin) + var(--header-height) - var(--header-hour-height) - 10px);
  width: 150px;
  height: fit-content;
  z-index: 10;
  display: block;
  box-shadow: 0 0 40px -14px rgba(0, 0, 0, 0.4);
  background: white;
}

.pause-container .header {
  height: 40px;
  position: relative;
  width: 100%;
  background: rgb(229, 196, 31);
  text-align: center;
  font-family: DistrictProBold;
  font-size: 25px;
  color: #404040;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pause-container .pauses {
  background: #f2f2f2;
  left: 0;
  top: 40px;
}

.pause-container .employee-pause {
  width: 150px;
  height: 150px;
  float: left;
  position: relative;
}
.pause-container .employee-pause .circle {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 120px;
  height: 120px;
  border-radius: 200px;
  background: #e5c41f;
  overflow: hidden;
}
.pause-container .employee-pause .circle .cover-left,
.pause-container .employee-pause .circle .cover-right,
.pause-container .employee-pause .circle .cover-mid {
  height: 100%;
  width: 50%;
  position: absolute;
  background: #e5e5e5;
}
.pause-container .employee-pause .circle .cover-left {
  top: 0;
  left: 25%;
}

.pause-container .employee-pause .circle .cover-mid {
  top: 0;
  left: 25%;
  background: #e5c41f;
  transform: translate(50%, 0%);
}

.pause-container .employee-pause .circle .cover-right {
  top: 0;
  left: 25%;
}

.pause-container .employee-pause .picture,
.pause-container .employee-pause .timer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 90px;
  height: 90px;
  border-radius: 200px;
  overflow: hidden;
  background: #ccc url("/images/avatar.png");
  background-size: contain;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}


.pause-container .employee-pause .icon {
  background: #e5c41f;
  position: absolute;
  top: 15px;
  left: 15px;
  width: 40px;
  height: 40px;
  border-radius: 200px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pause-container .employee-pause .icon.fa-utensils {
  font-size: 20px;
}

.pause-container .employee-pause .timer {
  background: #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 50px;
  font-family: DistrictProBold;
  color: white;
  line-height: 0;
}

.employee.overtime .bg img {
  box-shadow: 0 0 0 3px #e51550;
}

.employee.pause .bg img {
  box-shadow: 0 0 0 3px #e5c41f;
}

.bg .fas,
.bg .pause-time {
  display: none;
}

.bg .fa-coffee,
.bg .fa-utensils {
  display: block;
  font-size: 12px;
  color: #777;
  display: block;
  position: absolute;
  top: 2px;
  right: 65px;
  bottom: 0;
  margin: auto;
  height: fit-content;
  z-index: 2;
}

.overtime-show .fas,
.pause-show .pause-time {
  display: block;
  position: absolute;
  top: 0;
  right: 20px;
  bottom: 0;
  margin: auto;
  height: fit-content;
  color: #777;
  z-index: 2;
}

.overtime-show .fas {
  height: 25px;
  width: 25px;
  border-radius: 200px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding-top: 1px;
  z-index: 2;
}

.pause-show .pause-time {
  font-size: 12px;
  color: #777;
  font-family: DistrictProBold;
  z-index: 2;
}

.fa-clock:before {
  content: "\f017";
}

.shift-overtime {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #e51550;
}

.name-shadow {
  position: absolute;
  right: 0;
  top: 1px;
  width: 25px;
  box-shadow: inset -20px 0 5px 0px white;
  height: calc(100% - 2px);
  z-index: 1;
}

.pause-show .name-shadow {
  width: 90px;
  box-shadow: inset -85px 0 5px 0px white;
}

.overtime-show .name-shadow {
  width: 55px;
  box-shadow: inset -45px 0 5px 0px white;
}

.maintenance {
  width: calc(100vw);
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #282828;
}


.stripes{
background: repeating-linear-gradient(
  -50deg,
  #D18686 ,
  #D18686 10px,
  #F3E7E7 10px,
  #F3E7E7 20px
);
border-left: 3px solid #B64444;
}

.legalRest11{
  font-weight: bold;
  text-shadow: -2px -2px 10px #000;
  text-shadow: 2px -2px 10px #000;
  text-shadow: -2px 2px 10px #000;
  text-shadow: 2px 2px 10px #000;

  position: absolute;
  z-index: 999;
  text-align: left;
  color: white;
  font-size: 14px;
  font-family: DistrictProBook;
  top: -1px;
  bottom: 0;
  height: fit-content;
}
</style>
